/* global document */
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import ReactDOM from 'react-dom';

import { isNewAlerts } from 'common/helpers/featureFlags';

const LoginLogout = () => {
  if (Cookies.get('customerToken')) {
    const customer = jwtDecode(Cookies.get('customerToken'));
    customer.id = customer.sub;
    if (isNewAlerts(customer)) {
      return ReactDOM.createPortal(
        <>
          <a href="/profile" className="c7-login__with-alert">
            Hello {customer.firstName},
            <span className="c7-login__alert">1</span>
          </a>{' '}
          <a href="/profile/logout">Logout</a>
        </>,
        document.getElementById('c7-login')
      );
    }
    return ReactDOM.createPortal(
      <>
        <a href="/profile" className="c7-login__logged-in">
          Hello {customer.firstName}
        </a>{' '}
        <a href="/profile/logout" className="c7-login__logout">
          Logout
        </a>
      </>,
      document.getElementById('c7-login')
    );
  }

  return ReactDOM.createPortal(
    <>
      <a href="/profile/login">Login</a>
    </>,
    document.getElementById('c7-login')
  );
};

export default LoginLogout;
